import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { ProductServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Product Master section
 */
const useListProduct = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["product-list", page_no], ProductServices.productList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddProduct = (onSuccess, onError = onDefaultError) => {
  return useMutation(ProductServices.addProduct, {
    onSuccess,
    onError,
  });
};
const useUpdateProduct = (onSuccess, onError = onDefaultError) => {
  return useMutation(ProductServices.updateProduct, {
    onSuccess,
    onError,
  });
};
const useViewProduct = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("product-view", () => ProductServices.viewProduct({ id }), {
    onSuccess,
    onError,
  });
};
const useProductDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(ProductServices.deleteProduct, {
    onSuccess,
    onError,
  });
};
const useProductStatusChange = (onSuccess, onError = onDefaultError) => {
  return useMutation(ProductServices.updateStatusProduct, {
    onSuccess,
    onError,
  });
};
export {
  useListProduct,
  useAddProduct,
  useUpdateProduct,
  useViewProduct,
  useProductDelete,
  useProductStatusChange,
};
